import { render, staticRenderFns } from "./weightLimitDataGrid.vue?vue&type=template&id=0e23bb96&"
import script from "./weightLimitDataGrid.vue?vue&type=script&lang=js&"
export * from "./weightLimitDataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e23bb96')) {
      api.createRecord('0e23bb96', component.options)
    } else {
      api.reload('0e23bb96', component.options)
    }
    module.hot.accept("./weightLimitDataGrid.vue?vue&type=template&id=0e23bb96&", function () {
      api.rerender('0e23bb96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/grid/weightLimitDataGrid.vue"
export default component.exports